import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { BaseComponent } from '@ids-components';
import { ThreatService } from '@ids-services';
import { CardComponent, CommonTableComponent } from '@microsec/components';
import { SharedDetectedDeviceDetailsComponent } from '../../../../../../../shared-components/shared-detected-device-details/shared-detected-device-details.component';
import { DrawerModule } from 'primeng/drawer';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-threat-group-devices',
  templateUrl: './threat-group-devices.component.html',
  styleUrls: ['./threat-group-devices.component.scss'],
  imports: [CommonModule, TooltipModule, DrawerModule, CardComponent, CommonTableComponent, SharedDetectedDeviceDetailsComponent],
})
export class ThreatGroupDevicesComponent extends BaseComponent implements OnInit {
  _devices: any = null;

  get devices() {
    return this._devices;
  }

  @Input() set devices(value: any[]) {
    this._devices = value || [];
    this.selectedDevice = null;
  }

  _selectedDevice = null;

  get selectedDevice() {
    return this._selectedDevice;
  }

  set selectedDevice(value: any) {
    this._selectedDevice = value;
    this.displayDeviceDetails = !!value;
  }

  displayDeviceDetails = false;

  cols: any[] = [
    { field: 'label', header: 'Name', width: 20 },
    { field: 'mac_address', header: 'MAC Address', width: 15 },
    { field: 'ip_address', header: 'IP Addresses', width: 15 },
  ];

  selectedCols: any[] = [];

  _selectedColFields: string[] = [];

  get selectedColFields(): string[] {
    return this._selectedColFields;
  }

  set selectedColFields(value: string[]) {
    this._selectedColFields = value;
    this.selectedCols = (this.cols || []).filter((col) => value?.includes(col.field));
  }

  constructor(private threatSrv: ThreatService) {
    super();
  }

  async ngOnInit(): Promise<void> {
    await this.prepareConfigs();
    this.selectedColFields = (this.cols || []).map((col) => col.field);
  }

  isArray(value: any) {
    return !!Array.isArray(value);
  }
}
